// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zkLd","badges":"styles_badges__3YsWL"};